import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-paginationbar",
  templateUrl: "./paginationbar.component.html",
  styleUrls: ["./paginationbar.component.css"],
})
export class PaginationbarComponent implements OnInit {
  @Output() callFunction = new EventEmitter();
  @Input() data: any = [];
  @Input() setSelectedPage: any = 0;

  constructor() {}

  ngOnInit = (): void => {
    try {
      this.onClick({ value: this.setSelectedPage });
    } catch (error) {}
  };

  onClick = (event: any) => {
    try {
      if (event === "nextButton") {
        this.setSelectedPage = this.setSelectedPage + 1;
        this.callFunction.emit(this.setSelectedPage);
      } else if (event === "previousButton") {
        this.setSelectedPage = this.setSelectedPage - 1;
        this.callFunction.emit(this.setSelectedPage);
      } else {
        this.setSelectedPage = event.value;
        this.callFunction.emit(this.setSelectedPage);
      }
    } catch (error) {
      console.log("onClick catch===>", error);
    }
  };

  //to disable  pagination prev button
  setPrevButtonDisabled = (): boolean => {
    try {
      if (this.setSelectedPage === 0) {
        return true;
      }
    } catch (error) {
      console.log("setPrevButtonDisabled()=============>", error);
    }
  };

  //to disable  pagination next button
  setNextButtonDisabled = (): boolean => {
    try {
      if (this.setSelectedPage + 1 === this.data.length) {
        return true;
      }
    } catch (error) {
      console.log("setNextButtonDisabled()===============>", error);
    }
  };
}
